import {
  Box,
  Stack,
  Heading,
  Text,
  ContentBlock,
  List,
} from 'braid-design-system';

import { Header } from '#src/components/Header/Header';
import { PageWrapper } from '#src/components/PageWrapper/PageWrapper';

export const About = () => (
  <PageWrapper>
    <Box>
      <ContentBlock>
        <Box paddingY="xlarge" paddingX={{ mobile: 'gutter', tablet: 'none' }}>
          <Stack space="xlarge">
            <Stack space="large">
              <Heading level="1">
                Who are the Parents & Friends Association?
              </Heading>
              <Text>
                We are a group of dedicated parents, carers and friends whom
                endeavour to provide positive experiences for the whole school
                community.
              </Text>
            </Stack>
            <Stack space="large">
              <Heading level="2">
                What does the PFA provide for the APPS community?
              </Heading>
              <List>
                <Text>
                  Multiple school events organised and run by our team
                </Text>
                <Text>Supporting events jointly run with the school staff</Text>
                <Text>Distributing regular school bookclubs deliveries</Text>
                <Text>Organising the student ‘Birthday Bucket’</Text>
                <Text>Fundraising events for </Text>
              </List>
            </Stack>
            <Stack space="large">
              <Heading level="2">Join the PFA</Heading>
              <Text>
                Interested to find out more or possibly join our team? Contact
                us
              </Text>
            </Stack>
            <Stack space="large">
              <Heading level="2">Volunteering opportunities</Heading>
              <Text>
                If you can’t commit to joining the PFA then we are always after
                volunteer helpers to assist with:
              </Text>
              <List>
                <Text>Food and drink sales</Text>
                <Text>Student security and wrangling</Text>
                <Text>General event setup tasks</Text>
                <Text>Promotion and community engagement</Text>
                <Text>Design and copywriting</Text>
              </List>
            </Stack>
          </Stack>
        </Box>
      </ContentBlock>
    </Box>
  </PageWrapper>
);
